export default __webpack_public_path__ + "static/media/close-group-icon.29f85fd3.svg";